// extracted by mini-css-extract-plugin
export var dividerLine = "_7z-3";
export var itemImage = "_7z-9";
export var lightDivider = "_7z-4";
export var modalContent = "_7z-5";
export var modalContentCompact = "_7z-6";
export var productCard = "_7z-a";
export var productImage = "_7z-b";
export var productImageCompact = "_7z-7";
export var productImagePlaceholder = "_7z-c";
export var productImagePlaceholderCompact = "_7z-8";
export var progressBarBackground = "_7z-1";
export var progressBarContainer = "_7z-0";
export var progressBarFill = "_7z-2";